let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c5tM0")).then(() => parcelRequire('1luBV'));